<!-- Page Header -->
<app-page-header
  title="Kundenübersicht"
  subtitle="Suche und verwalte alle Kundenkonten"
  icon="people"
  variant="gradient">
</app-page-header>

<!-- Search Field -->
<div class="apple-container apple-slide-up">
  <div class="apple-search-card apple-card">
    <mat-form-field appearance="outline" class="apple-search-field">
      <mat-label>Suche nach Kunde</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Kundennr, Firma (Kurz), E-Mail..."
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
<div class="apple-container">
  <div class="apple-customer-table-card apple-card">
    <table
      mat-table
      [dataSource]="dataSource"
      class="apple-customer-table"
    >
    <!-- Customer No Column -->
    <ng-container matColumnDef="customerNo">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        Kundennr.
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.customerNo }}
      </td>
    </ng-container>

    <!-- Company Short Name Column -->
    <ng-container matColumnDef="companyShortName">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        Firma (Kurz)
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.companyShortName }}
      </td>
    </ng-container>

    <!-- Mail Column -->
    <ng-container matColumnDef="mail">
      <th mat-header-cell *matHeaderCellDef class="global-table-header-cell">
        E-Mail
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        {{ customer.mail }}
      </td>
    </ng-container>

    <!-- Details Column -->
    <ng-container matColumnDef="details">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="global-table-header-cell"
        style="min-width: 90px"
      >
        Details
      </th>
      <td mat-cell *matCellDef="let customer" class="global-table-cell">
        <button
          mat-flat-button
          color="primary"
          class="apple-details-btn"
          [routerLink]="['/admin/customers/details', customer.customerNo]"
          routerLinkActive="active"
        >
          <span>Details</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
      class="apple-table-header-row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; let i = index; columns: displayedColumns"
      class="apple-table-row"
    ></tr>
  </table>
  <mat-paginator
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 50]"
    showFirstLastButtons
    class="apple-paginator"
  ></mat-paginator>
  </div>
</div>
